import { Power4 } from "gsap"

export const ANIMATION = {
  DURATION: 0.9,
  EASE: Power4.easeInOut,
}

export const THEME_COLORS = [
  { color1: "#ffbd2f", color2: "#e1ff88" },
  { color1: "#f189ff", color2: "#9ce0ff" },
  { color1: "#72e970", color2: "#35b4ff" },
  { color1: "#ff6047", color2: "#ff98e3" },
]

export const TIMEOUT = 20000
export const DELAY = 300

export const BGCOLOR = "#ffffff"
